import {createReducer} from '@reduxjs/toolkit'
import {setBaseEnvironment, setFormFactor} from '../actions/environment'
import {EnvironmentConfig} from '../types/state'

const defaultState: EnvironmentConfig = {} as EnvironmentConfig

export const environment = createReducer(defaultState, builder => {
  builder
    .addCase(setBaseEnvironment.fulfilled, (state, action) => {
      return {...state, ...action.payload}
    })
    .addCase(setFormFactor, (state, action) => {
      return {...state, mobile: action.payload}
    })
})
